import { useState, useCallback } from "react";

// Shared card ↔ list view-mode state for the Requests pages (agent + club).
// URL ?view_mode= takes precedence (shareable / back-button friendly),
// otherwise the last choice in localStorage, else "card". Persisting to both
// keeps the choice across navigation and reloads. Used by AgentTenders and
// the club Requests view so both behave identically.
export const useViewMode = (storageKey = "requestsViewMode") => {
  const [viewMode, setViewMode] = useState(() => {
    try {
      const fromUrl = new URLSearchParams(window.location.search).get(
        "view_mode"
      );
      if (fromUrl === "card" || fromUrl === "list") return fromUrl;
      const stored = window.localStorage.getItem(storageKey);
      if (stored === "card" || stored === "list") return stored;
    } catch (e) {
      /* SSR / disabled storage — fall through to default */
    }
    return "card";
  });

  const changeViewMode = useCallback(
    (mode) => {
      const next = mode === "list" ? "list" : "card";
      setViewMode(next);
      try {
        window.localStorage.setItem(storageKey, next);
        const url = new URL(window.location.href);
        url.searchParams.set("view_mode", next);
        window.history.replaceState({}, "", url);
      } catch (e) {
        /* storage / history unavailable — state still updates in-memory */
      }
    },
    [storageKey]
  );

  return [viewMode, changeViewMode];
};
